import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";

class GiaoChoNguoiKhac extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  render() {
    let props = this.props;

    return (
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i class="mdi mdi-account-arrow-right"></i>
            </span>{" "}
            Giao việc cho người khác
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form class="form tat-toan form-horizontal form-edit">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse1969912"
                  class="card-header border-info"
                  href="#collapse1969912"
                  aria-expanded="true"
                  aria-controls="collapse1969912"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Người nhận việc</h3>
                  </a>
                </div>
                <div
                  id="collapse1969912"
                  aria-labelledby="headingCollapse969912"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Mã công việc"
                                disabled="disabled"
                                value="CV_20180806_0001"
                              ></TextInputOnRow>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Nhân viên</label>
                                <select class="selectBox form-control input-sm">
                                  <option value="0">Nguyễn Thu Hà</option>
                                  <option value="4">Nguyễn Anh Đức</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Liên quan đến hợp đồng"
                                disabled="disabled"
                                value=""
                              ></TextInputOnRow>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Ngày bắt đầu</label>
                                <input
                                  type="text"
                                  class="form-control input-sm datepicker-default"
                                  value="15/10/2018"
                                />
                              </div>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Ngày kết thúc</label>
                                <input
                                  type="text"
                                  class="form-control input-sm datepicker-default"
                                  value="20/10/2018"
                                />
                              </div>
                            </div>

                            <div class="col-md-4"></div>

                            <div class="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Tên công việc"
                                disabled="disabled"
                                value="Đi đòi nợ"
                              ></TextInputOnRow>
                            </div>

                            <div class="col-md-8">
                              <div class="form-group">
                                <label>Nội dung công việc</label>
                                <textarea
                                  rows="2"
                                  class="form-control input-sm"
                                  name="comment"
                                  disabled
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse1968812"
                  class="card-header border-info"
                  href="#collapse1968812"
                  aria-expanded="true"
                  aria-controls="collapse1968812"
                >
                  <a class="card-title lead info collapsed" href={() => false}>
                    <h3>Người giao việc</h3>
                  </a>
                </div>
                <div
                  id="collapse1968812"
                  aria-labelledby="headingCollapse968812"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Người giao việc"
                                disabled="disabled"
                                value="Nguyễn Thanh Trúc"
                              ></TextInputOnRow>
                            </div>

                            <div class="col-md-4">
                              <div class="form-group">
                                <label>Chức vụ</label>
                                <select
                                  class="selectBox form-control input-sm"
                                  disabled
                                >
                                  <option value="0">Chủ</option>
                                  <option value="4">Quản lý</option>
                                  <option value="5">Nhân viên</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Giao việc
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default GiaoChoNguoiKhac;
